import { isEmpty, isNil } from 'lodash';

import { eventPool } from '@/event/eventPool';
import { customReport, CustomReportType, reportResponse } from '@/report/tam';
import { getAuthPath, getDomain, isWoa } from '@/utils/getApiDomain';
import { appendParams } from '@/utils/url';

import { CgiErrorCode, CgiResp, CgiTrpcResp } from './cgi';

export const HTTP_ERROR = -80080;

const domain = getDomain();
const authPath = getAuthPath();
export const API_PREFIX_IPBOT = `${domain}/nova${authPath}/ipbot/outline/v1`;
export const API_PREFIX_AI = `${domain}/nova${authPath}/ai/v1`;
export const API_PREFIX_AGENT = `${domain}/nova${authPath}/agent/v1`;
export const API_PREFIX_PLOT = `${domain}/nova${authPath}/plot/outline/v1`;
export const API_PREFIX_AI_RESOURCE = `${domain}/nova${authPath}/plot/outline/v1/airesource`;
export const API_PREFIX_MATERIAL = `${domain}/nova/cms_platform/material/v1`;
export const API_PREFIX_WOA_AUTH = `${domain}/nova/cms_platform/auth/v1`;
export const API_PREFIX_FINANCE = `${domain}/nova${authPath}/plot/outline/v1/finance`;
export const API_PREFIX_AI_NOVEL = `${domain}/nova/ainovel/v1`;
export const API_PREFIX_NOVEL_WORLD = `${domain}/nova/novelworld/v1`;
export const API_PREFIX_PICBOOK = `${domain}/nova/picbook/v1`;
export const API_PREFIX_WALLET = `${domain}/nova/cms/plot/outline/v1/wallet`;

export const API_PREFIX_TRPC = `${domain}/trpc.nova.backend.Ai`;
export const API_PREFIX = API_PREFIX_PLOT;
export const API_BOTH_PREFIX_TRPC = isWoa ? API_PREFIX_AI : API_PREFIX_TRPC;

export async function request<T = CgiResp<any>>(
  url: string,
  _config: any = {},
) {
  try {
    const { body, query, signal, ...config } = _config;

    let requestUrl = url;

    if (!isEmpty(query)) {
      requestUrl = appendParams(url, query);
    }

    const response = await fetch(requestUrl, {
      body: body && JSON.stringify(body),
      headers: {
        'content-type': 'application/json',
      },
      signal,
      ...config,
      mode: 'cors',
      credentials: 'include',
    });

    const data: T = await response.json();

    const httpErrorMsg = await httpError(response);
    reportResponse(response, url, { ...data, httpErrorMsg }, httpErrorMsg);

    const loginError = await loginErrorHandle(data);
    if (loginError) {
      customReport(CustomReportType.TRPC_ERROR_CODE, data as CgiTrpcResp<T>);

      return {
        code: 50010,
      } as unknown as { code: number } & T;
    }

    if (httpErrorMsg) {
      return {
        code: HTTP_ERROR, // http error,
        msg: httpErrorMsg,
      } as unknown as { code: number } & T;
    }

    if (
      (data as any)?.code === 100002
      && !window.location.href.includes('403')
    ) {
      window.location.href = '/woa403';
    }

    return data;
  } catch (error) {
    return {
      code: CgiErrorCode.NotLogin,
    } as unknown as { code: number } & T;
  }
}

export const httpError = async (response: Response) => {
  const { status } = response;
  if (status >= 500 && status <= 599) {
    return '服务器处理失败，请稍后重试';
  }

  if (status >= 400 && status <= 499) {
    return '请求错误或无权限';
  }

  if (status < 200 || status > 299 || isNil(status)) {
    return '未知错误';
  }

  return '';
};

export const loginErrorHandle = async (data: any) => {
  const { ret } = data;
  if (ret === CgiErrorCode.UniNotLogin
    || ret === CgiErrorCode.TrpcNtLogin
    || ret === CgiErrorCode.ErrLogin
  ) {
    emitOpenLogin();
    return '登录态失效，请重新登录';
  }

  if (ret === CgiErrorCode.NeedRefresh) {
    emitRefreshLogin();
  }
  return '';
};

export const emitOpenLogin = () => {
  eventPool.eventsEmit.openLogin();
};

export const emitRefreshLogin = () => {
  eventPool.eventsEmit.refreshLogin();
};

